import * as EnumDatepicker from "@tunnel-enums/styled/index";
import styled, { css } from "styled-components";

/**
 * @interface IconProps
 * @description :
 * Cette interface définit le model du props
 */

interface IconProps {
  isrotate?: boolean;
  rotates?: boolean;
}

/**
 * @description : modification des props
 * @const
 * @name  layoutAll
 */
export const layoutAll = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: transparent;
`;
/**
 * @description : modification des props
 * @const
 * @name  Input
 */
export const Input = styled.input<ContainerInputProps>`
  top: 0;
  left: 0;
  border: none;
  overflow: hidden !important;
  padding: 0;
  height: 45px;
  width: 100%;
  padding-left: 5px;

  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  transition: box-shadow 0.3s ease;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }

  &:disabled {
    background: ${EnumDatepicker.CSS.GREY};
  }
  ${(props: ContainerInputProps) =>
    props.error &&
    css`
      border: 1px solid #ed5b56;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  ContainerBalise
 */
export const ContainerBalise = styled.div<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  z-index: 100;
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${EnumDatepicker.CSS.WHITE};
  padding-left: 0px;
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  border: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  ::before {
    content: "";
    position: absolute;
    height: 45px;
    width: 50px;
    right: 0px;
    top: 0px;
    background-color: ${EnumDatepicker.CSS.COLOR + "20"};
    border-left: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
    border-radius: 0 ${EnumDatepicker.CSS.BORDER_RADIUS}
      ${EnumDatepicker.CSS.BORDER_RADIUS} 0;
    cursor: pointer;
  }

  ${(props: ContainerInputProps) =>
    props.error &&
    css`
      border: 1px solid #ed5b56;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  inhibitionContentCarousel
 */
export const inhibitionContentCarousel = styled.div<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;
/**
 * @description : modification des props
 * @const
 * @name  ContentCarousel
 */
export const ContentCarousel = styled.div<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 0;
  height: 100%;
  min-height: 100px;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  box-sizing: border-box;
`;
/**
 * @description : modification des props
 * @const
 * @name  ContentCarouselInner
 */
export const ContentCarouselInner = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  display: flex;
`;
/**
 * @description : modification des props
 * @const
 * @name  ContentCarouselInnerPosition
 */
export const ContentCarouselInnerPosition = styled.div`
  width: auto;
  height: auto;
  display: flex;
`;
/**
 * @description : modification des props
 * @const
 * @name  NavigationCarousselLeft
 */
export const NavigationCarousselLeft = styled.div<BoxContainerProps>`
  top: 0;
  left: 0;
  width: 40px;
  height: 100%;
  min-height: 100px;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  align-content: center;
  position: absolute;
  box-sizing: border-box;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0s ease 0.3s;
  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      opacity: 1;
      visibility: visible;
      transition: opacity 0.2s ease, visibility 0s ease;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  BoxForms
 */
export const BoxForms = styled.div<BoxContainerProps>`
  width: 100%;
  min-height: 20px;
  position: relative;
  box-sizing: border-box;
  z-index: 9999;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.2s ease, visibility 0.3s ease;
  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease, visibility 0s ease;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  NavigationCarousselRight
 */
export const NavigationCarousselRight = styled.div`
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  min-height: 100px;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  align-content: center;
  position: absolute;
  box-sizing: border-box;
  z-index: 9999;
`;
/**
 * @description : modification des props
 * @const
 * @name  BullControl
 */
export const BullControl = styled.div`
  top: 0;
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  box-sizing: border-box;
  border-radius: 50%;
  background: #007adf69;
  cursor: pointer;
  color: white;
  font-size: 2.1em;
  text-align: center;
  &:hover {
    background: #007adf;
    transition: background 0.5s ease;
  }
`;

/**
 * @description : modification des props
 * @const
 * @name  ContainerInput
 */
export const ContainerInput = styled.div<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  z-index: 100;
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${EnumDatepicker.CSS.WHITE};
  padding-left: 0px;
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  border: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  ${(props: ContainerInputProps) =>
    props.error &&
    css`
      border: 1px solid #ed5b56;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  BoxContainer
 */
export const BoxContainer = styled.div<BoxContainerProps>`
  width: 100%;
  padding: 10px;
  height: 115px;
  box-sizing: border-box;
  -moz-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -ms-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -webkit-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: absolute;
  z-index: 10000;
  top: 40px;
  transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  display: flex;
  flex-direction: column;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  BoxContainersuggestion
 */
export const BoxContainersuggestion = styled.div<BoxContainerProps>`
  width: 100%;
  height: auto;
  box-sizing: border-box;
  -moz-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -ms-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -webkit-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: relative;
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  ::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 51px;
    right: 0px;
    top: 0px;
    border-radius: 0 ${EnumDatepicker.CSS.BORDER_RADIUS}
      ${EnumDatepicker.CSS.BORDER_RADIUS} 0;
    cursor: pointer;
  }

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      opacity: 1;
      visibility: visible;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  BoxContainersuggestionText
 */
export const BoxContainersuggestionText = styled.div<any>`
  border: 1px solid #cad1d9;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  display: inline-block;
  white-space: nowrap;
  -webkit-transition: background-color 0.2s ease-in-out, border 0.2s ease-in-out;
  transition: background-color 0.2s ease-in-out, border 0.2s ease-in-out;
  cursor: default;
  background: #fff;
  position: relative;
  padding: 4px 6px;
  margin: 2px;
  box-sizing: border-box;
`;

/**
 * @description : modification des props
 * @const
 * @name  BoxSnapshotContainer
 */
export const BoxSnapshotContainer = styled.div<BoxContainerProps>`
  width: 100%;
  padding: 10px;
  height: 120px;
  box-sizing: border-box;
  -moz-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -ms-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -webkit-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: absolute;
  z-index: 10000;
  top: 40px;
  transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  display: flex;
  flex-direction: column;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  Container
 */
export const Container = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

/**
 * @description : modification des props
 * @const
 * @name  Icon
 */
export const Icon = styled.div<IconProps>`
  position: absolute;
  right: 20px;
  width: 20px;
  transition: transform 0.33s ease;
  cursor: pointer;
  transform: rotate(0);

  ${(props: IconProps) =>
    props.isrotate &&
    css`
      transform: rotate(180deg);
      opacity: 1;
      visibility: visible;
      transition: transform 0.4s ease;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  IconRotate
 */
export const IconRotate = styled.div<IconProps>`
  position: absolute;
  right: 20px;
  width: 20px;
  transition: transform 0.33s ease;
  cursor: pointer;
  transform: rotate(0);
  ${(props: IconProps) =>
    props.rotates &&
    css`
      transform: rotate(180deg);
      opacity: 1;
      visibility: visible;
      transition: transform 0.4s ease;
    `}
`;
// snackbar
/**
 * @description : modification des props
 * @const
 * @name  SnackbarBoxContainer
 */
export const SnackbarBoxContainer = styled.div<BoxContainerProps>`
  min-width: 100px;
  padding: 10px 20px;
  height: auto;
  box-sizing: border-box;
  -moz-box-shadow: 1px 0px 3px 0px rgba(78, 78, 78, 0);
  -ms-box-shadow: 1px 0px 3px 0px rgba(78, 78, 78, 0);
  -webkit-box-shadow: 1px 0px 3px 0px rgba(78, 78, 78, 0);
  box-shadow: 1px 0px 3px 0px rgba(78, 78, 78, 0);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  position: fixed;
  z-index: 10000;
  right: 2%;
  bottom: 0;
  transform: translateY(40px);
  opacity: 0;
  visibility: hidden;
  color: $tunnelWhite;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  display: flex;
  flex-direction: column;
  color: ${EnumDatepicker.CSS.WHITE};
  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      transform: translateY(0);
      opacity: 1;
      bottom: 25px;
      visibility: visible;
      transition: transform 0.3s ease, bottom 0.2s ease, opacity 0.2s ease,
        visibility 0s ease;
    `}
`;
// horizontal display
/**
 * @description : modification des props
 * @const
 * @name  HorrizontalDisplayContainer
 */
export const HorrizontalDisplayContainer = styled.div<BoxContainerProps>`
  width: 100%;
  padding: 10px;
  height: auto;
  box-sizing: border-box;
  -moz-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -ms-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -webkit-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: relative;
  z-index: 10000;
  top: 30px;
  transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease;
    `}
`;
/// Breadcrumb
/**
 * @description : modification des props
 * @const
 * @name  BreadBoxContainer
 */
export const BreadBoxContainer = styled.div<BoxContainerProps>`
  width: 100%;
  padding: 10px;
  height: auto;
  box-sizing: border-box;
  -moz-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -ms-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  -webkit-box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  box-shadow: 5px 2px 30px 0px rgba(230, 230, 230, 0.45);
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: absolute;
  z-index: 10000;
  top: 30px;
  transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  transform-origin: top center;
  transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
  display: flex;
  flex-direction: column;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  SubmenuText
 */
export const SubmenuText = styled.div<BoxContainerProps>`
  width: 10.8em;
  height: 0;
  position: relative;
  left: 0;
  padding: none;
  margin-bottom: 0;
  box-sizing: border-box;
  font-size: 14px;
  opacity: 1;
  visibility: hidden;
  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      height: auto;
      margin-bottom: 0.5em;
      padding: 0.8em 0 0 5em;
      visibility: visible;
      transition: transform 0.6s ease, opacity 0.6s ease, height 0.6s ease,
        visibility 0.6s ease;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  BreadContainerBalise
 */
export const BreadContainerBalise = styled.div<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 35px;
  z-index: 100;
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${EnumDatepicker.CSS.WHITE};
  padding-left: 0px;
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  border: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  ::before {
    content: "";
    position: absolute;
    height: 35px;
    width: 35px;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }

  ${(props: ContainerInputProps) =>
    props.error &&
    css`
      border: 1px solid #ed5b56;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  BreadContainerBaliseForm
 */
export const BreadContainerBaliseForm = styled.form<ContainerInputProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 35px;
  z-index: 100;
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${EnumDatepicker.CSS.WHITE};
  padding-left: 0px;
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  border: 1px solid ${EnumDatepicker.CSS.BORDERCOLOR};
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  ::before {
    content: "";
    position: absolute;
    height: 35px;
    width: 35px;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }

  ${(props: ContainerInputProps) =>
    props.error &&
    css`
      border: 1px solid #ed5b56;
    `}
`;

/**
 * @description : modification des props
 * @const
 * @name  paginationBtnVirtual
 */
export const paginationBtnVirtual = styled.div`
  width: 100%;
  height: auto;
  text-align: right;
  position: absolute;
  margin-top: 0.02em;
  bottom: 0;
  left: 0;
  right: 0;
`;
/**
 * @description : modification des props
 * @const
 * @name  spanPagination
 */
export const spanPagination = styled.span<ContainerInputProps>`
  display: inline-block;
  cursor: pointer;
  margin: 0 2px !important;
  padding: 4px 7px;
  color: black;
  border-radius: 10%;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  border: 1px solid ${EnumDatepicker.CSS.BORDERCOLORTUNNEL};
  &:hover {
    background-color: ${EnumDatepicker.CSS.BORDERCOLORTUNNEL};
    color: ${EnumDatepicker.CSS.WHITE};
  }
  ${(props: ContainerInputProps) =>
    props.active &&
    css`
      background-color: ${EnumDatepicker.CSS.BORDERCOLORTUNNEL};
      color: ${EnumDatepicker.CSS.WHITE};
    `}
  ${(props: ContainerInputProps) =>
    props.isVisible &&
    css`
      opacity: 1;
      visibility: visible;
    `}
`;
// ====================================================================================================
////////////    MODAL //////////
/**
 * @description : modification des props
 * @const
 * @name  ModalContainer
 */
export const ModalContainer = styled.div<ModalContainerProps>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: ${EnumDatepicker.CSS.MODAL};
  position: fixed;
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  display: none;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      opacity: 1;
      display: block;

      visibility: visible;
    `}
`;
/**
 * @description : modification des props
 * @const
 * @name  ModalContainerInsider
 */
export const ModalContainerInsider = styled.div<ModalContainerProps>`
  width: auto;
  height: auto;
  padding: 5px;
  box-sizing: border-box;
  border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
  overflow: hidden;
  background: ${EnumDatepicker.CSS.WHITE};
  position: absolute;
  z-index: 10000;
  transform: translate(-50%, -10%);
  left: 50%;
  top: 50%;
  opacity: 0;
  display: none;
  visibility: hidden;

  ${(props: BoxContainerProps) =>
    props.isVisible &&
    css`
      opacity: 1;
      display: flex;
      transform: translate(-50%, -50%);
      flex-direction: column;
      visibility: visible;
      transition: opacity 0.5s ease, visibility 0.5s ease, transform 5s ease;
    `}
`;

// ====================================================================================================
{
  /** BOUTONS */
}
// ====================================================================================================
/**
 * @description : modification des props : input de type checkbox
 * @const
 * @name  CheckBoxNormal
 */
export const CheckBoxNormal = styled.input<any>`
  position: absolute;
  opacity: 0;

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  & + label:before {
    content: "";
    display: inline-block;
    vertical-align: text-top;
    width: 15px;
    height: 15px;
    background: #e9eff4;
    box-shadow: 0 0 0 1px white;
    border-radius: 50%;
  }

  &:hover + label:before {
    background: white;
    box-shadow: 0 0 0 1px #e9eff4;
    border-radius: 50%;
  }

  &:checked + label:before {
    background: rgb(0, 122, 223);
    border-radius: 50%;
    box-shadow: 0 0 0 1px #e9eff4;
  }

  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  &:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  &:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }

  &:not(:checked) + label:after,
  &:checked + label:after {
    content: "";
    position: absolute;
    left: 0.21em;

    transition: all 0.2s;
  }
`;

// ====================================================================================================
{
  /** INTERFACES */
}
// ====================================================================================================
/**
 * @interface BoxContainerProps
 * @description :
 * Cette interface définit le model du props
 */
interface BoxContainerProps {
  isVisible?: boolean;
  rotate?: boolean;
}
/**
 * @interface ModalContainerProps
 * @description :
 * Cette interface définit le model du props
 */
interface ModalContainerProps {
  isVisible?: boolean;
}

/**
 * @interface ContainerInputProps
 * @description :
 * Cette interface définit le model du props
 */
interface ContainerInputProps {
  error?: boolean;
  active?: boolean;
  arrowLeft?: boolean;
  arrowRight?: boolean;
  isVisible?: boolean;
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@styled/styled/index.ts